export default __webpack_public_path__ + "media/music/77f9ecdff60133f96b39930c3e8087dd.mp3";